<template>
  <organism-idc-create-edit-contact-point-or-sale
    v-model="contactPointOrSaleDetail"
    :cardTitle="cardTitle"
    :locationOption="locationOption"
    @onConfirmCreateNewContactPointOrSale="onConfirmCreateNewContactPointOrSale"
    @onConfirmEditContactPointOrSale="onConfirmEditContactPointOrSale"
    @onUpdateProfilePicture="onUpdateProfilePicture"
  ></organism-idc-create-edit-contact-point-or-sale>
</template>

<script>
import OrganismIdcCreateEditContactPointOrSale from "@/components/organisms/portal/internal/idc/OrganismIdcCreateEditContactPointOrSale.vue"
import {
  getLocationList,
  createNewContactPointOrSale,
  updateProfilePicture,
  getContactPointOrSaleDetailById,
  updateContactPointOrSale,
} from "@/api/api-module1"
import mixins from "@/mixins"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
export default {
  name: "IdcCreateEditContactPointOrSale",
  components: {
    OrganismIdcCreateEditContactPointOrSale,
  },
  mixins: [mixins, mixinsObjectHelper],
  data() {
    return {
      locationOption: [],
      contactPointOrSaleDetail: {
        id: "",
        profilePicture: null,
        firstName: "",
        lastName: "",
        idOrPassportNumber: "",
        role: null,
        email: {
          primary: "",
          secondary: "",
          third: "",
        },
        phone: {
          primary: "",
          secondary: "",
          third: "",
        },
        accesses: [],
      },
    }
  },
  computed: {
    contactPointOrSaleId() {
      return this.$route?.params?.id
    },
    cardTitle() {
      return this.isEmptyValue(this.contactPointOrSaleId)
        ? "Create New Contact Point/Sale"
        : "Contact Point/Sale"
    },
  },
  watch: {
    contactPointOrSaleId() {
      if (this.contactPointOrSaleId) {
        this.contactPointOrSaleDetail.id = this.contactPointOrSaleId
      }
    },
  },
  async mounted() {
    if (this.contactPointOrSaleId) {
      this.contactPointOrSaleDetail.id = this.contactPointOrSaleId
      await this.getContactPointOrSaleDetailByIdFromApi()
    }
    await this.getLocationListFromApi()
  },
  methods: {
    navigateTo(path) {
      this.$router.push(path)
    },

    onConfirmCreateNewContactPointOrSale() {
      const contactPointOrSaleDataToApi =
        this.decorateContactPointOrSaleDataToApi()
      this.createNewContactPointOrSaleApi(contactPointOrSaleDataToApi)
    },

    onConfirmEditContactPointOrSale() {
      const contactPointOrSaleDataToApi =
        this.decorateContactPointOrSaleDataToApi()
      const contactPointOrSaleId = this.contactPointOrSaleDetail.id
      this.updateContactPointOrSaleApi(
        contactPointOrSaleId,
        contactPointOrSaleDataToApi
      )
    },

    onUpdateProfilePicture(profilePicture) {
      this.currentProfilePicture = profilePicture
    },

    decorateContactPointOrSaleDataToApi() {
      const contactPointOrSaleDataToApi = {
        contactType: this.contactPointOrSaleDetail.role.toUpperCase(),
        firstname: this.contactPointOrSaleDetail.firstName.trim(),
        lastname: this.contactPointOrSaleDetail.lastName.trim(),
        idType: this.contactPointOrSaleDetail.idType,
        identification: this.contactPointOrSaleDetail.idOrPassportNumber,
        emails: this.getEmailList(),
        phones: this.getPhoneList(),
        accesses: this.getAccessList(),
      }
      return contactPointOrSaleDataToApi
    },

    getEmailList() {
      let emailList = [
        this.contactPointOrSaleDetail.email.primary,
        this.contactPointOrSaleDetail.email.secondary,
        this.contactPointOrSaleDetail.email.third,
      ]
      emailList = emailList
        .filter((email) => email.email && email.email.trim())
        .map((email) => ({ ...email, email: email.email.trim() }))
      let uniqueEmailList = emailList.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.email === value.email)
      )
      return uniqueEmailList
    },

    getPhoneList() {
      let phoneList = [
        this.contactPointOrSaleDetail.phone.primary,
        this.contactPointOrSaleDetail.phone.secondary,
        this.contactPointOrSaleDetail.phone.third,
      ]
      phoneList = phoneList.filter((phone) => phone.phone)
      let uniquePhoneList = phoneList.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.phone === value.phone)
      )
      return uniquePhoneList
    },

    getAccessList() {
      return this.contactPointOrSaleDetail.accesses.map((access) => {
        return {
          contactPointAccessId: access.contactPointAccessId,
          accessCardNumber: access.accessCardNumber,
          locationId: access.locationId,
        }
      })
    },

    async getLocationListFromApi() {
      this.showLoading(true)
      await getLocationList()
        .then((response) => {
          this.locationOption = response.data.map((location) => {
            return {
              ...location,
              label: `${
                location.siteName ? location.siteName : "Site Not Found"
              } - ${location.locationName}`,
            }
          })
        })
        .finally(() => this.showLoading(false))
    },

    async getContactPointOrSaleDetailByIdFromApi() {
      this.showLoading(true)
      await getContactPointOrSaleDetailById(this.contactPointOrSaleId)
        .then((response) => {
          this.contactPointOrSaleDetail = this.deepCopyObject(response.data)
        })
        .finally(() => this.showLoading(false))
    },

    async createNewContactPointOrSaleApi(newContactPointOrSaleData) {
      this.showLoading(true)
      await createNewContactPointOrSale(newContactPointOrSaleData)
        .then((response) => {
          if (response) {
            this.toastSuccess("Create Contact Point/Sale Successfully")
            if (this.currentProfilePicture) {
              const contactId = response.data
              this.updateProfilePictureApi(contactId)
            } else {
              this.navigateTo("/internal/web-portal/idc/contact")
            }
          } else {
            this.toastError("Create Contact Point/Sale Failed")
            this.navigateTo("/internal/web-portal/idc/contact")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async updateContactPointOrSaleApi(
      contactPointOrSaleId,
      contactPointOrSaleDataToApi
    ) {
      this.showLoading(true)
      await updateContactPointOrSale(
        contactPointOrSaleId,
        contactPointOrSaleDataToApi
      )
        .then((response) => {
          if (response) {
            this.toastSuccess("Update Successfully")
            if (this.currentProfilePicture) {
              this.updateProfilePictureApi(contactPointOrSaleId)
            } else {
              this.navigateTo("/internal/web-portal/idc/contact")
            }
          } else {
            this.toastError("Update Failed")
            this.navigateTo("/internal/web-portal/idc/contact")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async updateProfilePictureApi(contactId) {
      this.showLoading(true)
      await updateProfilePicture(this.currentProfilePicture, contactId)
        .then((response) => {
          if (response) {
            this.toastSuccess("Update Profile Picture Successfully")
            this.navigateTo("/internal/web-portal/idc/contact")
          } else {
            this.toastError("Update Profile Picture Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    isEmptyValue(input) {
      return input === null || input === undefined || input.length === 0
    },
  },
}
</script>

<style lang="scss" scoped></style>
